import { Descriptions } from "antd";
import { damageCaseStatusOptions } from "../../baseInfo/damageCase/interfaces";
import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { ComparisonFilter } from "../../components/infrastructure/filtering";
import { IDamageCaseVoucherItem, IDamageCaseVoucherItemProps, IDamageCaseVoucherItemStates } from "../interfaces";
import dayjs from 'dayjs';

export class DamageCaseVoucherPaymentItem extends EntityManager<IDamageCaseVoucherItem, IDamageCaseVoucherItemProps, IDamageCaseVoucherItemStates>{

    static initMetadata = (): IMetadata => {
        return {
            title: "اقلام حواله",
            name: "DamageCaseVoucherPaymentItem",
            Properties: [
                {
                    title: "شماره پرونده",
                    dataIndex: "DamageCase.Code",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "شماره پیگیری",
                    dataIndex: "DamageCase.TicketNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "وضعیت پرونده",
                    dataIndex: "DamageCase.Status",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: { options: damageCaseStatusOptions },
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "سریال بیمه نامه",
                    dataIndex: "DamageCase.Policy.SerialNo",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "کد ملی بیمه گزار/مشتری",
                    dataIndex: "PolicyholderNationalCode",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "بیمه گزار/مشتری",
                    dataIndex: "PolicyholderFullName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: false,
                    sortable: false,
                    width: 200
                },
                {
                    title: "مبلغ قابل دریافت",
                    dataIndex: "Amount",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    filterable: false,
                    sortable: false,
                    width: 180,
                    formatter: (value) => {
                        return `ريال ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    }
                }

            ]
        };
    }
    onInitializing() {
        this.searchable = true;
        this.searchArea = {
            columnsPerRow: 2
        };

        this.originalFilter = () => {
            return ComparisonFilter.Equal<IDamageCaseVoucherItem>(i => i.VoucherId, this.props.params().voucher.Id);
        };

        this.extraHeaderNodes = () => {
            const { voucher } = this.props.params();
            const chequeDate = voucher.ChequeDate ? dayjs(voucher.ChequeDate).calendar('jalali').locale('fa').format("YYYY/MM/DD") : "";
            const issueDate = voucher.ChequeDate ? dayjs(voucher.IssueDate).calendar('jalali').locale('fa').format("YYYY/MM/DD") : "";

            return (
                <Descriptions column={{ xxl: 4, xl: 4, lg: 2, md: 2, sm: 1, xs: 1 }} className="header-page">
                    <Descriptions.Item label="شماره حواله">{voucher.VoucherNo}</Descriptions.Item>
                    <Descriptions.Item label="تاریخ صدور">{issueDate}</Descriptions.Item>
                    <Descriptions.Item label="شماره چک">{voucher.ChequeNo}</Descriptions.Item>
                    <Descriptions.Item label="تاریخ چک">{chequeDate}</Descriptions.Item>
                </Descriptions>
            );
        };
    }
}